import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { DELETE_ONORARIO } from '../../data.const';
import {
  retrieveOnorarioListAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const deleteOnorarioEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(DELETE_ONORARIO),
    map(({ payload: { ids, ...rest } }: any) => ({
      body: {
        ids,
      },
      listBody: rest,
    })),
    // tap(p => console.log(`[epic ${DELETE_ONORARIO}]`, p)),
    withLatestFrom(state$),
    switchMap(([{ body, listBody }, _state]) => {
      return concat(
        of(setLoaders({ onorarioLoader: true })),
        defer(() =>
          from(
            request({ path: `onorario`, method: httpMethods.DELETE, body })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p;
            }),
            // tap(p => console.log(`[epic ${DELETE_ONORARIO}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(() => of(retrieveOnorarioListAction(listBody))),
            catchError(err => {
              console.error(`[epic ${DELETE_ONORARIO}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ onorarioLoader: false }))
      );
    })
  );

export default deleteOnorarioEpic;
